import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const LivestreamPage = lazy(() => import('@cobliteam/livestream'));

const routes = [
  {
    path: Location.LIVESTREAM,
    component: LivestreamPage,
    featureFlag: 'livestreamPage',
    accessDeniedDescription: 'ver vídeos ao vivo',
  },
];

export default routes;
